import { render } from "./StatMatieres.vue?vue&type=template&id=78cfb77a"
import script from "./StatMatieres.vue?vue&type=script&lang=js"
export * from "./StatMatieres.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__